// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-group-tree__item-row[data-v-721aa168]:hover{cursor:default}.m-group-tree__tree[data-v-721aa168]{position:relative}.m-group-tree__tree[data-v-721aa168]  .v-treeview-node{border-top:1px solid rgba(0,0,0,.12)}.m-group-tree__text[data-v-721aa168]{vertical-align:bottom}", ""]);
// Exports
module.exports = exports;
